// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"8e79904e","331":"fe109fa8","393":"509c697f","461":"31a07b33","787":"74f42b25","849":"cc629b3d","883":"248bc8a1","925":"3c595905","943":"c339c27e","965":"d15188eb"}[chunkId] + ".chunk.js";
};